import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";
import { StroageService } from "../service/stroage";

declare var alertify: any;
declare var $: any;
@Component({
  templateUrl: "./fiveGoalTask.html",
})
export class FiveGoalTask implements OnInit {
  constructor(
    private router: Router,
    private http: HttpService,
    private storage: StroageService
  ) {}

  private data: any = [];
  ngOnInit(): void {
    this.getData();
  }
  private getData() {
    this.http.getData(API.getFiveGoal).then((res) => {
      this.data = res.data;
      for (let item of this.data) {
        item.description = item.description.replace(/<[^>]+>/g, "");
      }
    });
  }

  private editProduct(id: number) {
    this.router.navigate(["index/fiveGoalTask", id]);
  }
  private searchProduct(id: number) {
    this.router.navigate(["index/challengeMission", id]);
  }
  //
  private deleteProduct(id: number): void {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.deleteData(API.getFiveGoal + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }

  private showBudeng(): void {
    let _self = this;
    let alertObj = alertify
      .alert(
        "補登",
        `
    <div id='budeng'>
      
      <input type="radio" id="1" name="type" value="1" checked>
      <label for="1">參與活動</label>
      <input type="radio" id="2" name="type" value="2">
      <label for="2">邀約</label>
      <button type="submit" class="btn btn-primary" id="downloadTemp">
        下載模板
      </button>
      <div style="display:flex">
        <input type="file" single id="fileupload" name="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
        <button type="button" id="fileupload-btn" class="btn btn-primary">
          上傳
        </button>
      </div>
      <p style="color:red">該功能只處理上傳文件會自動過濾錯誤數據</p>
    </div>
    `,
        function () {}
      )
      .set({
        onclose: function () {
          $("#downloadTemp").off("click", downloadTemp);
          $("#fileupload-btn").off("click", fileuploadChange);
        },
      })
      .set("label", "關閉");

    $("#downloadTemp").click(downloadTemp);

    function downloadTemp() {
      let type = $('input[name="type"]:checked').val();
      _self.http.download(API.getFiveGoalTemplate, { type }).then((res) => {
        console.log(res);
      });
    }

    $("#fileupload-btn").click(fileuploadChange);

    function fileuploadChange(e) {
      $("#fileupload-btn").attr("disabled", true);
      let file = $("#fileupload")[0].files[0];
      let type = $('input[name="type"]:checked').val();
      var formData = new FormData();
      formData.append("file", file);
      formData.append("type", type);
      var xhr = new XMLHttpRequest();
      xhr.open("POST", API.uploadFiveGoalTemplate);
      xhr.setRequestHeader("token", _self.storage.getStroage("token"));
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let res = JSON.parse(xhr.responseText);
          if (res.data == 0) {
            alertify.error("成功" + res.data + "條,請檢查文檔中的數據格式");
          } else {
            alertify.success("成功" + res.data + "條");
          }
          alertObj.close();
          $("#fileupload-btn").attr("disabled", false);
        }
      };
      xhr.send(formData);
    }
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/task/fiveGoalTask.component.ts